import React from 'react';
import { Redirect } from "react-router-dom";

import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import BottomNavigation from 'components/BottomNavigation'
import Loading from 'components/Loading'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import Matrix from 'scripts/Matrix'
import { Button } from '@material-ui/core';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import { Link } from 'react-router-dom'
import TermsAndConditionModal from 'components/TermsAndConditionModal'
import SendIcon from '@material-ui/icons/Send';
import SearchIcon from '@material-ui/icons/Search'

import style from 'style/consult/NewConsult.css'
import axios from 'axios';
import utils from '../../Utils'
import ConsultCategoryItem from './ConsultCategoryItem';
import store from '../../scripts/store';
import 'style/consult/NewConsult.css'
import queryString from 'query-string'
import DoctorListItem from './DoctorListItem'
import DoctorProfile from './DoctorProfile'
import ConsultRequestButton from './ConsultRequestButton'
import history from '../../history'





const STEP_CATEGORY = 1
const STEP_DOCTORS = 2
const DOCTOR_PROFILE = 3
const STEP_QUESTION = 4
const STEP_PURCHASE = 5
const DESC_CATEGORY = 'انتخاب بخش مشاوره'
const DESC_DOCTORS = 'انتخاب دکتر'
const DESC_QUESTION = 'پرسش سوال'
class NewConsult extends React.Component {

  constructor(props) {
    super(props)

    let categoryId, question

    if (window.localStorage.getItem('questionFromBlog')) {
      const questionFromBlog = JSON.parse(window.localStorage.getItem('questionFromBlog'))

      categoryId = questionFromBlog.categoryId
      question = questionFromBlog.question
    }

    this.queries = new URLSearchParams(history.location.search)

    const consultRequestId = this.props.location.state && this.props.location.state.consultId
    const checkConsultRequestId = this.props.location.state && this.props.location.state.consultRequest
    const checkDoctorId = this.props.location.state && this.props.location.state.doctorId
    const checkVoiceConsult = this.props.location.state && this.props.location.state.voiceConsult

    this.state = {
      loading: false,
      couponLoading: false,
      redirect: '',
      categories: [],
      categoryToShow: [],
      step: checkConsultRequestId ? STEP_PURCHASE : checkDoctorId || checkVoiceConsult ? STEP_QUESTION : question ? STEP_PURCHASE : this.queries.get('id') ? STEP_DOCTORS : STEP_CATEGORY,
      headerDesc: DESC_CATEGORY,
      sendLoading: false,
      consultCategory: {},
      wallet: {},
      discountBtnToggle: true,
      coupon: '',
      couponId: '',
      discountPrice: null,
      consultRequestId: '',
      doctors: [],
      data: {
        question: question ? question : '',
        ConsultCategoryId: checkDoctorId ? null : categoryId ? categoryId : this.queries.get('id') ? this.queries.get('id') : 0,
        callback: utils.urls.askQuestionCallbackURL,
      },
      acceptTerms: false,
      disableButton: false,
      firstConsultCode: ''
    }
  }

  apiGetAllConsultCategory = async () => {
    this.setState({ loading: true })
    let result = await axios.get(utils.urls.consultCategories).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ loading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success, consultCategories } = result.data;

    await consultCategories.sort((a, b) => a.position - b.position)

    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ categories: consultCategories, categoryToShow: consultCategories })
  }

  componentWillUpdate() {
    window.onpopstate = () => {
      this.setState({ step: STEP_CATEGORY });
    }
  }

  async componentDidMount() {
    if (this.props.location.state && this.props.location.state.consultRequest) this.justCompletePayment()
    if (this.state.data.ConsultRequestId) {
      this.setState({
        headerDesc: DESC_QUESTION,
        step: STEP_QUESTION,
      })
      return
    }
    await this.apiGetAllConsultCategory()

    const wallet = await store.getWallet()
    this.setState({ wallet })

    if (this.queries.get('id')) this.handleWithCategoryId()
    if (this.props.location.state && (this.props.location.state.category)) {
      this.onCategoryClicked(this.props.location.state.category)
    }

    if (window.localStorage.getItem('questionFromBlog')) this.initAsk()
  }

  handleWithCategoryId = () => {
    this.apiGetDoctors(this.state.data.ConsultCategoryId)
    this.state.categories.map(i => {
      if (i.id === parseInt(this.state.data.ConsultCategoryId, 10)) {
        this.setState({ consultCategory: { ...this.state.consultCategory, price: i.price } });
      }
    })
  }

  justCompletePayment = async () => {
    const { consultRequest: { question, price, ConsultCategoryId }, discount } = this.props.location.state.consultRequest

    await this.setState({
      data: { ...this.state.data, question, ConsultCategoryId },
      consultCategory: { price },
      consultRequestId: this.props.location.state.consultRequest.consultRequest.id,
      discountPrice: discount ? price - discount.newPrice : null,
      coupon: discount ? discount.Coupon.code : '',
      couponId: discount ? discount.id : ''
    });
    this.isFirstConsult()

    if (discount) this.toggle()
  }

  onCategoryClicked = (category) => {
    this.setState({
      headerDesc: DESC_DOCTORS,
      step: STEP_DOCTORS,
      consultCategory: category,
      data: { ...this.state.data, ConsultCategoryId: category.id }
    })

    history.push(`?id=${category.id}`, { categoryId: category.id })
    this.apiGetDoctors(category.id)
  }

  resizeInput = () =>{
    const textarea = this.refs.textInput
    if (textarea && textarea.scrollHeight < 300) {
      textarea.style.height = 0 // has to set to 0 for shrinking
      textarea.style.height = textarea.scrollHeight + 'px'
    }

  }
  onTextInputHandle = (event) => {
    const textarea = this.refs.textInput
    if (textarea.scrollHeight < 300) {
      textarea.style.height = 0 // has to set to 0 for shrinking
      textarea.style.height = textarea.scrollHeight + 'px'
    }

    this.setState({ data: { ...this.state.data, question: event.target.value } })
  }

  apiSendQuestion = async () => {
    if (!this.state.data.question || this.state.data.question.length < 60)
      return this.SnackBar.openSnackbar('متن سوال بیش از 60 حرف باشد')
    this.setState({ sendLoading: true })
    let url = this.state.data.ConsultRequestId ? utils.urls.consultAskQuestionWithQuiz : utils.urls.consultAskQuestion
    let result = await axios.post(url, { ...this.state.data }, {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    this.setState({ sendLoading: false })

    if (!result) return
    // console.log(result, '###############')

    let { success } = result.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
    this.setState({ redirect: { pathname: '/chats' } })
  }

  formatMoney = (price) => {
    return (parseInt(price)).toLocaleString("fa-IR", { minimumFractionDigits: 0 })
  }

  calcTotal = () => {
    const { discountPrice, consultCategory: { price }, wallet: { credit } } = this.state
    const fee = (price - discountPrice) - credit
    if (fee >= 0) return this.formatMoney(fee)
    if (fee < 0) return 0
  }

  toggle = () => this.setState({ discountBtnToggle: !this.state.discountBtnToggle })

  onBack = () => {
    const { step } = this.state

    if (step === STEP_PURCHASE) {
      this.setState({ step: STEP_QUESTION, headerDesc: DESC_QUESTION })
    } else if (step === STEP_QUESTION) {
      this.setState({ headerDesc: DESC_CATEGORY })
      window.localStorage.removeItem('questionFromBlog')
      history.goBack()
    } else if (step === STEP_DOCTORS) {
      this.setState({
        step: STEP_CATEGORY,
        headerDesc: DESC_CATEGORY,
        doctors: []
      })
      history.push('/consult/new')
    } else {
      this.setState({ redirect: '/chats' })
    }
  }

  gotoPurchase = async () => {
    this.setState({ disableButton: true })

    if (this.state.data.question && this.state.data.question.length > 60) {

      if (this.props.location.state && this.props.location.state.voiceConsult)
        await this.initAsk('voice')
      else
        await this.initAsk('text')
  
      this.isFirstConsult()
      this.setState({ disableButton: false })
      return this.setState({ step: STEP_PURCHASE })
    }

    this.SnackBar.openSnackbar('متن سوال بیش از 60 حرف باشد')
    this.setState({ disableButton: false })
  }

  isFirstConsult = async () =>{
    let result = await axios.post(utils.urls.isFirstConsult,{}, {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    }).catch((e) => {
      console.log(e)
    });
    if (!result) return
    let { success, code} = result.data;
    if(success) this.setState({firstConsultCode : code})
  }

  initAsk = async type => {
    // console.log(this.props.location.state)

    this.setState({ sendLoading: true })
    // TODO Ask with quiz
    // let url = this.state.data.ConsultRequestId ? utils.urls.consultAskQuestionWithQuiz : utils.urls.askinit
    let url = utils.urls.initAsk

    let params = { ...this.state.data, consultRequestId: this.state.consultRequestId, type }

    if (this.props.location.state && this.props.location.state.doctorId) {
      params = {
        ...this.state.data,
        consultRequestId: this.state.consultRequestId,
        doctorId: this.props.location.state.doctorId,
        type
      }
    }

    let result = await axios.post(url, params, {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    }).catch((e) => {
      console.log(e)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });
    if (!result) return

    let { success, chargeWalletUrl, consultRequest: { id, price, question } } = result.data;

    this.setState({
      sendLoading: false,
      consultRequestId: id,
      consultCategory: { price },
      data: { ...this.state.data, question }
    })

    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

    window.localStorage.removeItem('questionFromBlog')
    this.setState({ sendLoading: false })
  }

  apiSendCoupon = async (entityId) => {
    this.setState({ couponLoading: true })

    const params = {
      entity: 'ConsultRequest',
      code: this.state.coupon,
      entityId
    }

    let url = utils.urls.useCoupon

    if (!this.state.coupon) {
      this.setState({ couponLoading: false });
      return this.SnackBar.openSnackbar('لطفا کد تخفیف را وارد کنید.')
    }

    let res = await axios.post(url, params, {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    })
      .catch((e) => {
        console.log(e)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      });

    const { success, message } = res.data

    this.setState({ couponLoading: false })

    if (success) {
      const { discount: { initialPrice, newPrice, id } } = res.data

      this.setState({
        discountPrice: initialPrice - newPrice,
        couponId: id
      })
    }

    if (success) this.toggle()

    if (!res) return
    if (!success) return this.SnackBar.openSnackbar(message || 'خطایی پیش آمده است')
  }

  apiDeleteCoupon = async () => {
    this.setState({ couponLoading: true })

    let url = `${utils.urls.deleteCoupon}/${this.state.couponId}`

    let res = await axios.delete(url, {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    })
      .catch((e) => {
        console.log(e)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      });

    const { success } = res.data

    this.setState({
      couponLoading: false,
      coupon: '',
      couponId: '',
      discountPrice: null
    })

    this.toggle()

    if (!res) return
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
  }

  finalizePay = async () => {
    this.setState({ sendLoading: true })

    // let url = this.state.data.ConsultRequestId ? utils.urls.consultAskQuestionWithQuiz : utils.urls.consultNewAskQuestion
    let url = utils.urls.finalizeAsk
    const { consultRequestId, data: { callback } } = this.state

    let res = await axios.post(url, { consultRequestId: consultRequestId, callback: callback }, {
      headers: {
        'x-access-token': Matrix.getToken()
      }
    }).catch((e) => {
      console.log(e.response)
      let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
      this.SnackBar.openSnackbar(message)
    });

    this.setState({ sendLoading: false })

    if (res) {
      const { chargeWalletUrl, success } = res.data
      if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')
      if (chargeWalletUrl) {
        return window.location.replace(chargeWalletUrl)
      } else {
        this.setState({ redirect: { pathname: '/chats' } })
      }
    }
  }

  apiGetDoctors = async categoryId => {
    this.setState({ loading: true })

    let res = await axios.get(utils.urls.doctorsUrl(categoryId))
      .catch((e) => {
        console.log(e.response)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      });

    this.setState({ loading: false })

    if (!res) return

    let { success, consultCategories } = res.data;
    if (!success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

    this.append(res.data)
  }

  append = data => {
    let complex = {}
    let array = []


    data.doctors.map(doctor => complex[doctor.id] = doctor)

    data.consultRating.map(item => {
      if (!complex[item.doctorId]) return

      complex[item.doctorId] = {
        ...complex[item.doctorId],
        rateItem: item
      }
    })

    data.doctors.forEach(doctor => {
      if (!complex[doctor.id]) return

      array.push(complex[doctor.id])
    })

    this.setState({ doctors: array });
  }

  acceptTerms = e => this.setState({ acceptTerms: e.target.checked })

  getVoiceRequest = async () => {
    this.setState({ loading: true })

    const res = await axios.post(utils.urls.callRequest, { doctorId: this.props.location.state.doctorId }, { headers: { 'x-access-token': Matrix.getToken() } })
      .catch((e) => {
        console.log(e.response)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.props.openSnackbar(message)
      })

    this.setState({ loading: false })

    if (!res) return
    if (!res.data.success) return this.props.openSnackbar('خطایی پیش آمده است')

    this.setState({ open: false });
    this.props.openSnackbar(res.data.message, 'info')
    // window.open('tel:' + res.data.number, '_self')
  }
  question = () => {
    let doctorFullName, exp, category
    let avgResponse = 12
    let textArray = [
      `لطفا برای شروع مکالمه و گفتگو سوال خود را داخل کادر پایین نوشته و برای من ارسال کنید، تلاش میکنم تا ${avgResponse} ساعت آینده پاسخ شما را بدهم`,
      `بعد از شروع مکالمه، شما امکان ارسال جواب آزمایش یا عکس های پزشکی و پیام صوتی را هم خواهید داشت`
    ]

    let consultRequest,question, createdAt, ConsultCategory, doctor
    if(this.props.location.state && this.props.location.state.consultRequest) { // if in edit consult
      doctor  = this.props.location.state.consultRequest.consultRequest.doctor
      ConsultCategory  = this.props.location.state.consultRequest.consultRequest.ConsultCategory
    }
    else if( this.props.location.state && this.props.location.state.doctor) { // in new consult
      doctor = this.props.location.state.doctor
    }

    if (doctor) {
      doctorFullName = doctor.fname + ' ' + doctor.lname

      exp = doctor.expUnis?.length ?
        doctor.expUnis[0].expertise.name :
        doctor.spUnis?.length && doctor.spUnis[0] ?
        doctor.spUnis[0].specialty.name : ''

      avgResponse = doctor.DoctorConsultInfo?.avgResponse || 12

      textArray = [
        `سلام دکتر ${doctorFullName} هستم${exp && ' متخصص '+exp}`,
        ...textArray
      ]
    } else {
      this.state.categories.forEach(cat => {
        if (cat.id == this.state.data.ConsultCategoryId) category = cat.name
      })

      textArray = [
        `سلام، شما در حال مکالمه با یکی از پزشکان تخصص ${category} هستید`,
        ...textArray
      ]
    }

    return (
      <>
        <div className="background"></div>
        <div className="chatContainer">
          <div className="psudo">
            <div className="MessageRow">
              {textArray.map(txt =>
                <div className="ChatMessage" key={txt}>
                  <span className="text">{txt}</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="chatFooter">
          <div className="text-message">
            {this.state.disableButton ?
              <SendIcon style={{ marginLeft: 5, color: '#ccc' }} /> :
              <SendIcon style={{ marginLeft: 5 }} onClick={this.gotoPurchase} />
            }
            <div className="chatInputWrapper">
              <textarea
                rows="1"
                className="chatInput"
                placeholder="شرح حال ..."
                onChange={this.onTextInputHandle}
                onFocus={(this.resizeInput)}
                ref='textInput'
                value={this.state.data.question}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
  searchCat = e => {
    if (!e.target.value)
      this.setState({ categoryToShow: this.state.categories })
    else
      this.setState({ categoryToShow: this.state.categories.filter(cat => cat.name.includes(e.target.value)) })
  }

  searchDoctor = async e => {
    if (e.target.value && e.target.value.length >2) {
      const query = e.target.value

      const result = await axios.get(`${utils.urls.searchDoctor}?query=${query}`)
      .catch(e => {
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        this.SnackBar.openSnackbar(message)
      })
    
      if (!result) return

      if (!result.data.success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

      this.append(result.data)
    } else {
      this.setState({ doctors: [] })
    }
  }

  handleChange = async e => {
    this.searchCat(e)
    this.searchDoctor(e)
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }
    return (
      <React.Fragment>
        <Header title="درخواست مشاوره" showBackButton={true} desc={this.state.headerDesc} onBack={this.onBack}></Header>
        <div className="page-root" >
          <SnackBar ref={el => { this.SnackBar = el }}></SnackBar>
          <TermsAndConditionModal ref={el => this.TermsAndConditionModal = el} />

          {this.state.step === STEP_CATEGORY &&
            <div style={{ paddingRight: '10px', paddingLeft: '10px', overflowY: 'auto', flexGrow: 1 }}>
              <h3>ابتدا نوع مشاوره را مشخص کنید</h3>
              <div className="search-box">
                <input ref={el => this.searchInput = el} onChange={this.handleChange} placeholder="جستجوی تخصص یا موضوع مشاوره یا دکتر" />
                <SearchIcon style={{ marginRight: 5 }} onClick={() => this.searchInput.focus()} />
              </div>
              {!this.state.loading && this.state.categoryToShow.length !== 0 &&
                <div style={{ paddingBottom: '10px' }}>
                  <div className="doctors-list__title">انتخاب دسته‌بندی</div>
                  {this.state.categoryToShow.map(category =>
                    <ConsultCategoryItem key={category.id} category={category} onCategoryClicked={() => this.onCategoryClicked(category)}></ConsultCategoryItem>
                  )}
                </div>
              }
              {this.state.doctors.length !== 0 &&
                <div style={{ paddingBottom: '10px' }}>
                  <div className="doctors-list__title">پرسش از پزشک دلخواه</div>
                  {this.state.doctors.map(doctor =>
                    <Link key={doctor.id} to={`/doctors/${doctor.id}`}>
                      <DoctorListItem doctor={doctor} />
                    </Link>
                  )}
                </div>
              }

              {this.state.doctors.length === 0 && this.state.categoryToShow.length === 0 &&
                <div className="empty-list">موردی یافت نشد</div> 
              }

            </div>
          }

          {this.state.step === STEP_DOCTORS &&
            <div style={{ paddingBottom: '10px' }}>
              <ConsultRequestButton
                title={'پرسش از اولین پزشک'}
                subTitle={'پاسخ در سریع ترین زمان توسط یکی از پزشکان در دسترس'}
                onClick={() => this.setState({ step: STEP_QUESTION, headerDesc: DESC_QUESTION })}
                price={this.state.consultCategory.price}
                showIcon={true}
                btnText="ثبت درخواست"
              />
              <div className="doctors-list__title">پرسش از پزشک دلخواه</div>
              {this.state.doctors.map(doctor =>
                <Link key={doctor.id} to={`/doctors/${doctor.id}`}>
                  <DoctorListItem doctor={doctor} />
                </Link>
              )}
            </div>
          }

          {this.state.step === STEP_QUESTION && this.question()
            // <>
            //   <div style={{ flexGrow: 1, paddingRight: '10px', paddingLeft: '10px' }}>
            //     <h3>از پزشک چه سوالی دارید؟</h3>
            //     <span style={{ fontSize: '12px', marginTop: '-10px', display: 'block' }}>لطفا سوال خود را به صورت کامل در بخش زیر شرح دهید</span>
            //     <textarea
            //       rows="4"
            //       className="chatInput"
            //       placeholder="شرح حال ..."
            //       onChange={this.onTextInputHandle}
            //       ref='textInput'
            //       value={this.state.data.question}
            //       style={{ resize: 'none', backgroundColor: 'rgb(255, 255, 255)', border: 'none', direction: 'rtl', outline: 'none', overflowX: 'hidden', fontSize: '16px', padding: '8px', width: '100%', borderRadius: '8px' }}
            //     />
            //     <div className='char' style={{ fontSize: 10 }}>تعداد حرف پرسش {parseInt(this.state.data.question.length).toLocaleString("fa-IR", { useGrouping: false })}</div>
            //   </div>

            //   {this.state.sendLoading && <Loading></Loading>}
            //   <div onClick={this.gotoPurchase} style={{ textAlign: 'center', padding: '15px 0', background: '#1dc37e', color: '#fff' }}>
            //     ثبت و ادامه
            //   </div>
            // </>
          }

          {this.state.step === STEP_PURCHASE &&
            <>
              <div className='purchase'>
                <img src='/images/payment.svg' alt="مشاوره آنلاین پزشکی با بهترین دکترها" className='icon-image purchase-icon' />

                <span>پزشک در کوتاهترین زمان پاسخگوی شما خواهد بود</span>

                <div className="card">
                  <div className='card-title'>
                    <div className="card-indicator"></div>
                      کد تخفیف
                  </div>
                  <div className="row" style={{ justifyContent: 'flex-start' }}>
                    <div className="discount-code">
                      <div className="input-box">
                        <input
                          placeholder="افزودن کد تخفیف"
                          style={{ padding: '3px 10px' }}
                          value={this.state.coupon}
                          onChange={e => { this.setState({ coupon: e.target.value }); if (!e.target.value) { this.setState({ discountBtnToggle: true }); } }}
                        />
                        <div className="btn-box">
                          {this.state.discountBtnToggle ?
                            <button
                              className="action-btn"
                              onClick={() => this.apiSendCoupon(this.state.consultRequestId)}>
                              اعمال
                            </button> :
                            <button
                              className="cancel-btn"
                              onClick={this.apiDeleteCoupon}>
                              لغو
                            </button>}
                        </div>
                      </div>
                      {this.state.couponLoading && <Loading style={{ margin: 'auto', marginRight: 20, background: 'rgba(255, 255, 255, 0)', display: 'block', width: '35px', height: 25 }} />}
                    </div>
                </div>
              { this.state.firstConsultCode &&
                <div className="row first-consult">
                  <span>کد تخفیف اولین مشاوره</span>
                  <span class="code">{this.state.firstConsultCode}</span>
                </div>
              }
                  {/* <div className="row" style={{ margin: 10, color: 'rgba(0, 0, 0, 0.6) ' }}>
                    <span>
                      کد تخفیف تا پایان خردادماه:
                    </span>
                    <span style={{ marginRight: 10, fontWeight: '600', color: '#000' }}>tebinja9903</span>
                  </div> */}
                </div>

                <div className='card'>
                  <div className='card-title'>
                    <div className="card-indicator"></div>
                    اطلاعات پرداخت
                  </div>
                  <div className='row'>
                    <span>مشاوره با پزشک</span>
                    <div className='dot'></div>
                    <span className='price'>{this.formatMoney(this.state.consultCategory.price)} تومان</span>
                  </div>
                  {this.state.discountPrice &&
                    <div className='row'>
                      <span>تخفیف</span>
                      <div className='dot'></div>
                      <span className='price'>{this.formatMoney(this.state.discountPrice)} تومان</span>
                    </div>
                  }

                  <div className='row'>
                    <span>کیف پول</span>
                    <div className='dot'></div>
                    <span className='price'>{this.formatMoney(this.state.wallet.credit)} تومان</span>
                  </div>
                  <div className='row total-credit'>
                    <span>مبلغ قابل پرداخت</span>
                    <div className='dot'></div>
                    <span className='price'>{this.calcTotal()} تومان</span>
                  </div>
                </div>
                <div>
                  <Button onClick={() => { this.setState({ step: STEP_QUESTION }) }} variant="outlined" style={{ borderRadius: '23px', marginBottom: '10px' }}>
                    تغییر متن مشاوره
                <EditTwoToneIcon fontSize="small" />
                  </Button>
                </div>
              </div>

              <div className="terms">
                {/* <div className="terms__checkbox">
                  <input type="checkbox" checked={this.state.acceptTerms} onChange={this.acceptTerms} />
                  <div><span className="link" onClick={() => this.TermsAndConditionModal.openModal()}>قوانین و مقررات</span> را قبول دارم</div>
                </div> */}
                <div className="terms__checkbox">
                  <div>در صورت ادامه <span className="link" onClick={() => this.TermsAndConditionModal.openModal()}>قوانین و مقررات</span> را قبول دارم</div>
                </div>
              </div>
              {/* {this.state.acceptTerms ?
                <div className='purchase-btn button' style={{ marginBottom: 0 }} onClick={this.finalizePay}> پرداخت و ثبت نهایی</div> :
                <div className='purchase-btn button disable' style={{ marginBottom: 0, background: '#ccc' }} onClick={() => this.SnackBar.openSnackbar('قوانین و مقررات را مطالعه و تایید فرمایید')}> پرداخت و ثبت نهایی</div>
              } */}
              <div className='purchase-btn button' style={{ marginBottom: 0 }} onClick={this.finalizePay}> پرداخت و ثبت نهایی</div>
            </>
          }

          {this.state.loading && <div className="Loading"><Loading /></div>}
        </div>
      </React.Fragment>
    )
  }

}

export default NewConsult
